import { useEffect, useState } from "react";
import { errorNotify, errorNotifyByErrorObject, sucessNotify } from "../../services/toast.notification";
import { ValidationErrorSpan } from "../../styles/global";
import { useForm } from "../../utility/useForm";
import {  NoValidateForm } from "../../utility/validationRules";
import { FormProps } from '../../utility/types';
import Spinner from "../../components/_common/Spinner";
import { Col, Modal, Row } from "antd";
import FormContainer from "../../components/FormContainer/FormContainer";
import {  AssignInstallerForMachineInstallRequest, getParsicUser } from "../../api/api";
import CustomSelect from "../../components/_common/CustomSelect";
import { useAppSelector } from "../../redux/store/storehooks";

export const AssignInstallerDialog: React.FC<FormProps> = ({visible,onSubmit,onCancel,payLoad,setShowDialog}) => {

    const { values, errors, handleChange, handleSubmit,setErrors,setValues } = useForm(NoValidateForm) as any
    const myStore = useAppSelector((state) => state)
    const [isLoading,setIsLoading] = useState(true);
    const [isSubmiting,setIsSubmiting] = useState(false);
    const [parsicUserList,setParsicUserList] = useState();

    const ValidationType = ({ type }: any) => {
        const ErrorMessage = errors[type]; 
        return (
            <ValidationErrorSpan erros={errors[type]}>{ErrorMessage}</ValidationErrorSpan>
        );
    };

    useEffect( ()=>{
        loadParsicUsers();
    },[])


    
    const loadParsicUsers = () => {

        getParsicUser()
        .then((result:any) => {
            setParsicUserList(result.data.data)
            setIsLoading(false);
        })
        .catch((error:any) => {
          console.log(error);
          errorNotifyByErrorObject(error,undefined,5000)
        })

    }

    const onSubmitForm = (e:any) => {
        e.preventDefault();
  
        setIsSubmiting(true)

        AssignInstallerForMachineInstallRequest(
            Number(payLoad.requestid),
            myStore.auth.userId || 0,
            Number(values.parsicUser)
        ).then((result:any) => {
            sucessNotify("اطلاعات با موفقیت ثبت شد",undefined,5000)
            onCancel();
            setIsSubmiting(false)
        })
        .catch((error) => {
          console.log(error);
          setIsSubmiting(false)
          errorNotify(error.response.data.errorMessage,undefined,5000)
        })

    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            cancelButtonProps={{ style: { display: 'none' } }}
            okButtonProps={{ style: { display: 'none' } }}
        >
            <>
                {isLoading === true && (
                            <Spinner/>
                )}
                {isLoading === false && (

                    <FormContainer title="تعیین نصاب دستگاه" onSubmit={onSubmitForm} onCancel={() => setShowDialog(false)} isLoading={isLoading} isSubmiting={isSubmiting} >
                        
                        <Row>
                            <Col lg={24} md={24} sm={24} xs={24}>
                                <CustomSelect
                                    name="parsicUser"
                                    placeholder="نصاب دستگاه"
                                    itemList={parsicUserList}
                                    value={values.parsicUser || ""}
                                    onChange={handleChange}
                                    valueObjectField={"prk_ParsicUser_AutoID"}
                                    displayObjectField={"str_FullName"}
                                />
                                <ValidationType type="parsicUser" />
                            </Col>
                        </Row>

                    </FormContainer>

                )}
            </>
            
        </Modal>
    )
}